import React from 'react';
import { NavLink } from 'react-router-dom';
import { useEntitlement } from '../../hooks/useEntitlement';

const TABS: Array<{ to: string; label: string; gated: boolean }> = [
  { to: '/portfolio/positions', label: 'Positions', gated: false },
  { to: '/portfolio/portfolio', label: 'Portfolio', gated: true },
  { to: '/portfolio/performance', label: 'Performance', gated: true },
  // Replay hidden (Oct 2026): its twin comparison never acted and its data
  // stopped in July; to be rebuilt as a Discipline report.
];

/** Portfolio section tabs: underline tabs, with a small PRO tag on gated tabs for free users. */
const PortfolioTabNavigation: React.FC = () => {
  const { canUpgrade } = useEntitlement();
  return (
    <nav className="ptabs" aria-label="Portfolio sections">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => `ptab ${isActive ? 'is-on' : ''}`}>
          {t.label}
          {t.gated && canUpgrade && <span className="ptab-pro">Pro</span>}
        </NavLink>
      ))}
    </nav>
  );
};

export default PortfolioTabNavigation;
